import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DatePipe } from '@angular/common';

import {
  ColDef,
  GridOptions,
  GridReadyEvent
} from 'ag-grid-community';

import { Header } from '@aptsi-types';
import { RowTooltipComponent } from '../table/main-table/row-tooltip.component';

@Component({
  selector: 'app-report-table',
  templateUrl: './report-table.component.html',
  styleUrls: ['./report-table.component.scss'],
  providers: [DatePipe]
})
export class ReportTableComponent implements OnChanges {

  @Input() headers: Header[] = [];
  @Input() data: any[] = [];

  columnDefs: ColDef[] = [];

  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 100,
    filter: true,
    floatingFilter: true,

    // Return the complete row object to RowTooltipComponent.
    tooltipValueGetter: params => params.data,

    // Use the same registration approach as MainTableComponent.
    tooltipComponent: 'rowTooltip',

    tooltipComponentParams: {
      headers: this.headers
    }
  };

  gridOptions: GridOptions = {
    enableBrowserTooltips: false,

    tooltipShowDelay: 800,
    tooltipHideDelay: 10000,

    // Keep the tooltip open while the pointer moves onto it.
    tooltipInteraction: true,

    suppressDragLeaveHidesColumns: true,

    // Register the existing custom tooltip component.
    components: {
      rowTooltip: RowTooltipComponent
    },

    onColumnMoved: params => {
      setTimeout(() => {
        params.api.sizeColumnsToFit();
      }, 0);
    }
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['headers']) {
      this.columnDefs = this.headers.map(header => ({
        headerName: header.name,
        field: header.property,

        // Pass the current headers to the custom tooltip.
        tooltipComponentParams: {
          headers: this.headers
        },

        // Keep the header description separate from the row tooltip.
        headerTooltip: header.description || undefined
      }));
    }
  }

  onGridReady(params: GridReadyEvent): void {
    params.api.sizeColumnsToFit();
  }
}